/**
 * Animation capture scenes at `/mobile/sliding/animation/:slug`.
 * Independent from static `screenshotScenes.js`.
 */
export const SLIDING_ANIMATION_SCENES = [
    {
        slug: "01",
        id: "sliding-solve-demo",
        type: "solve-scramble-video",
        label: "Animation intro",
        storyId: "d0d64c7c-07ef-4697-a725-75af86a8d856",
        slidingId: "f7ad574b-2688-45bd-8333-08d4e985e147",
        promoHeadline: "Challenge Yourself",
        promoSubtitle: "Premium sliding puzzles.",
        /** Valid tile slides after the puzzle is solved, then reversed back to solved. */
        scrambleMoveCount: 5,
        moveDelayMs: 380,
        /** Wait a random duration in this range before each solve move (empty cell slide). */
        solveMoveDelayMinMs: 350,
        solveMoveDelayMaxMs: 750,
        /** Tile slide animation duration (ms) when empty cell moves. */
        slideTransitionMs: 160,
        brandTitle: "SLIDING PUZZLE QUEST",
        typewriterCharMs: 120,
        typewriterInitialDelayMs: 400,
        /** Hold after typewriter finishes on brand scene (scene 3). */
        brandHoldMs: 1200,
        /** Brief pause on solved board before scene 2 (video). */
        pauseAfterSolveMs: 400,
        completionVideoUrl:
            "https://puzzleinteract-images.s3.us-east-1.amazonaws.com/story/video/d0d64c7c-07ef-4697-a725-75af86a8d856.mp4",
        completionVideoSourceWidth: 1280,
        completionVideoSourceHeight: 720,
        completionVideoCropSize: 720,
        maxReloads: 3,
    },
];

export function getAnimationScene(slug) {
    return SLIDING_ANIMATION_SCENES.find((scene) => scene.slug === slug) ?? null;
}
